import React from 'react'

import EditCategoryForm from '../../modules/Category/components/EditCategoryForm'
export default function EditCategoryPage() {
  return <EditCategoryForm />
}
